/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_contact_success_body_idea = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your idea was received. We'll take a look soon.`)
};

const es_contact_success_body_idea = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hemos recibido tu idea. La revisaremos pronto.`)
};

const de_contact_success_body_idea = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Idee ist eingegangen. Wir schauen sie uns bald an.`)
};

const nl_contact_success_body_idea = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We hebben je idee ontvangen. We bekijken het binnenkort.`)
};

const fr_contact_success_body_idea = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre idée a bien été reçue. Nous y jetterons un œil bientôt.`)
};

const it_contact_success_body_idea = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbiamo ricevuto la tua idea. La esamineremo presto.`)
};

const pt_br2_contact_success_body_idea = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recebemos sua ideia. Vamos dar uma olhada em breve.`)
};

const pt_contact_success_body_idea = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recebemos a tua ideia. Vamos analisá-la em breve.`)
};

const ja_contact_success_body_idea = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイデアを受け取りました。近いうちに確認します。`)
};

const zh_contact_success_body_idea = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们已收到你的创意，会尽快查看。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_success_body_idea = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_success_body_idea(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("contact_success_body_idea", locale)
	if (locale === "en") return en_contact_success_body_idea(inputs)
	if (locale === "es") return es_contact_success_body_idea(inputs)
	if (locale === "de") return de_contact_success_body_idea(inputs)
	if (locale === "nl") return nl_contact_success_body_idea(inputs)
	if (locale === "fr") return fr_contact_success_body_idea(inputs)
	if (locale === "it") return it_contact_success_body_idea(inputs)
	if (locale === "pt-BR") return pt_br2_contact_success_body_idea(inputs)
	if (locale === "pt") return pt_contact_success_body_idea(inputs)
	if (locale === "ja") return ja_contact_success_body_idea(inputs)
	return zh_contact_success_body_idea(inputs)
};